export enum StorageKeysEnum {
  WL_OWNER_VISITING_CUSTOMER = 'wl-owner-visiting-customer',
}
